// extracted by mini-css-extract-plugin
module.exports = {"sub":"TransactionLaw_sub_3Q9S2","des":"TransactionLaw_des_1bagD","numlist":"TransactionLaw_numlist_3HoSK","main":"TransactionLaw_main_3GP1c","list":"TransactionLaw_list_2v6l0"};